export default class ParamHelper {
  static getLocationId(props) {
    return props.match.params.location_id;
  }

  static getPageId(props) {
    return props.match.params.page_id;
  }

  static getItemId(props) {
    return props.match.params.item_id;
  }

  static getTableId(props) {
    return props.match.params.table_id;
  }
  // static getItemIdInURL(url) {
  //   const regex = /(\/item\/\d+)/;
  //   var findItem = url.toString().match(regex);
  //   if (!findItem) { return null; }
  //   else { return findItem[0].split('/')[2]; }
  // }
  static getItemIdInURL(url) {
    let parts = url.split('/');
    let itemString = parts[parts.length - 1].split('-');
    if (!itemString) return null
    else return itemString[itemString.length - 1];
  }
}
